/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { computed } from '@angular/core';
import { signalStore, withState, withComputed, withMethods, patchState } from '@ngrx/signals';
import { ShipmentCommonModel } from '@well/delivery-libs/shipment/domain';

interface ShipmentCommonState {
  shipmentCommonModel: ShipmentCommonModel;
}

const initialState: ShipmentCommonState = {
  shipmentCommonModel: {
    orderUuid: null,
    shipmentUuids: [],
  },
};

export const ShipmentCommonStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withComputed((store) => ({
    orderShipmentsUuids: computed(() => store.shipmentCommonModel()?.shipmentUuids),
  })),

  withMethods((store) => ({
    updateShipmentCommonModel(model: ShipmentCommonModel): void {
      patchState(store, { shipmentCommonModel: model });
    },

    loadShipmentCommonModel(model: ShipmentCommonModel): void {
      patchState(store, { shipmentCommonModel: model });
    },

    clearShipmentCommonModel(): void {
      patchState(store, {
        shipmentCommonModel: { orderUuid: null, shipmentUuids: [] },
      });
    },
  }))
);
